/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RegisteredDevice } from '../../models/registered-device';
import { RegisteredDeviceCreateDto } from '../../models/registered-device-create-dto';

export interface UpdateRegDeviceBasicData$Params {
  deviceId: number;
      body: RegisteredDeviceCreateDto
}

export function updateRegDeviceBasicData(http: HttpClient, rootUrl: string, params: UpdateRegDeviceBasicData$Params, context?: HttpContext): Observable<StrictHttpResponse<RegisteredDevice>> {
  const rb = new RequestBuilder(rootUrl, updateRegDeviceBasicData.PATH, 'put');
  if (params) {
    rb.path('deviceId', params.deviceId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<RegisteredDevice>;
    })
  );
}

updateRegDeviceBasicData.PATH = '/api/regdevice/{deviceId}';
